import { useMutation } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";

type CreateVehicleComparisonViewPayload = {
  vehicleVariantIds: string[];
};

export const createVehicleComparisonView = (
  dossierId: string,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const { defaultOnMutateError, defaultOnMutateSuccess } = useAPQuery();

  return useMutation({
    mutationFn: (
      payload: CreateVehicleComparisonViewPayload
    ): Promise<string> => {
      return fetchWithAuth<string>(
        "createDossierVehicleComparisonView",
        dossierId,
        {
          requestOptions: {
            method: "post",
            body: JSON.stringify(payload),
          },
        }
      );
    },
    onError: defaultOnMutateError(options),
    onSuccess: defaultOnMutateSuccess(options),
  });
};
